








import EmptyState from '@getaccept/lib-shared/src/components/EmptyState.vue';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'EmptyStateRow',
  components: {
    EmptyState,
  },
  props: {
    imgSrc: {
      type: String,
      default: null,
    },
    message: {
      type: String,
      default: null,
    },
  },
});
